"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _standard = _interopRequireDefault(require("@/components/ImagePicker/standard.vue"));
var _order = require("@/api/order");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderWriteOff',
  components: {
    ImagePicker: _standard.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      orderInfo: {},
      images: []
    };
  },
  methods: {
    open: function open(data) {
      this.dialogVisible = true;
      this.orderInfo = data;
    },
    close: function close() {
      this.orderInfo = {};
      this.dialogVisible = false;
    },
    onWriteOff: function onWriteOff() {
      var _this = this;
      var o = {};
      o.images = this.images;
      (0, _order.writeUpdateApi)(this.orderInfo.verifyCode, o).then(function (res) {
        _this.$message.success('核销成功');
        _this.$emit('success');
        _this.close();
      });
    }
  }
};